import axios from 'axios';
import apiUrl from './apiUrl';
import sitecode from '../sitecode';

const apiv3 = axios.create({
  baseURL: apiUrl(sitecode, 'v3'),
  withCredentials: true,
  // Per-environment XSRF cookie name matching the backend's SESSION_XSRF_COOKIE
  // (see apiv4.js for the rationale).
  xsrfCookieName: process.env.VUE_APP_XSRF_COOKIE || 'XSRF-TOKEN',
});

export default apiv3;
